import {
    DataLayerActionField, DataLayerEcommerce, DataLayerEcommerceTxObject, DataLayerEcommerceDetails,
    DataLayerImpressionItem, DataLayerModel, DataLayerTxItem, CartData, SearchResultsEvent
} from "./DataLayerModels";

export const InitDataLayer = () => { window.dataLayer || [] };

// Why is this code in this file? It's got nothing to do with the datalayer
export const InitState = () =>
{
    if (!navigator.userAgent.match(/bot|spider/i))
    {
        // It's not a bot lets try to get the state if we don't already have one

        //check our tracking cookie first
        var stateID = "";
        var cookieArr = document.cookie.split(";");        
        for (var i = 0; i < cookieArr.length; i++)
        {
            var cookiePair = cookieArr[i].split("=");
            if ("_lacSettingsState" == cookiePair[0].trim())
            {
                stateID = decodeURIComponent(cookiePair[1]);
            }        
        }

        console.log("start state search")
        if (stateID == "")
        {
            $.ajax({
                url: "/Account/SetState",
                type: "POST",
                data: {},
                success: function () { console.log("passed state call") },
                error: function () {console.log("Failed state call") }
            });

        }
    } 
};


export class DataLayerModelFactory {

    public impressions = (products: Array<DataLayerImpressionItem>, event: string, eventLabel: string) => {

        let detail: DataLayerEcommerceDetails = {
            actionField: {
                list: document.title.split('|')[0].trim()
            }
        };

        let ecommerce: DataLayerEcommerce = {
            detail: detail,
            currencyCode: "USD",
            impressions: products
        }

        let obj: DataLayerModel = {
            ecommerce: ecommerce,
            event: event || null,
            eventLabel: eventLabel || null
        };

        return obj;
    };

    public addToCart = (product: DataLayerTxItem | Array<DataLayerTxItem>) => {

        let ecommerce: DataLayerEcommerce = {
            currencyCode: "USD",
            add: { product }
        };

        let obj: DataLayerModel = {
            ecommerce: ecommerce,
            event: "addToCart",
            eventLabel: "Added item to cart"
        }

        if (Array.isArray(product)) {
            obj.eventLabel = "Added many items to cart";
        }
        else {
            obj.eventLabel = "Added to cart: " + product.quantity + " unit" + (product.quantity > 1 ? "s" : "");
        }


        return obj;
    }

    public removeFromCart = (product: DataLayerTxItem | Array<DataLayerTxItem>) => {

        let ecommerce: DataLayerEcommerce = {
            currencyCode: "USD",
            remove: { product }
        };

        let obj: DataLayerModel = {
            ecommerce: ecommerce,
            event: "removeFromCart",
            eventLabel: "Removed item from cart"
        }

        if (Array.isArray(product)) {
            obj.eventLabel = "Removed many items from cart";
        }
        else {
            obj.eventLabel = "Removed from cart: " + product.quantity + " unit" + (product.quantity > 1 ? "s" : "");
        }

        return obj;
    }

    public checkout = (products: Array<DataLayerTxItem>, cartData: CartData) => {


        let shippingFee: string | number = "Pending";
        if (cartData.step !== 1) {
            shippingFee = cartData.shipping;
        }

        let actionField: DataLayerActionField = {
            id: cartData.id
        }

        if (cartData.step !== 4) {
            actionField.step = cartData.step;
        }

        let checkout: DataLayerEcommerceTxObject = {
            actionField: actionField,
            products: products,
            shipping: shippingFee,
            subtotal: cartData.subTotal
        }

        let purchase: DataLayerEcommerceTxObject = {
            actionField: actionField,
            products: products
        }

        let ecommerce: DataLayerEcommerce = {
            currencyCode: "USD"
        };


        let UserMeta = window.UserMeta;
        let CustomerID = "Not logged in";
        if (UserMeta) {
            CustomerID = UserMeta.CustomerID;
        }

        let City = "N/A";
        let State = "N/A";
        let Zip = "N/A";


        if (cartData.step !== 1) {
            City = cartData.csz.City;
            State = cartData.csz.State;
            Zip = cartData.csz.Zip;
        };

        if (cartData.step !== 4) {
            ecommerce.checkout = checkout;
        }

        let obj: DataLayerModel = {
            ecommerce: ecommerce,
            event: "checkout",
            eventLabel: "View Shopping Cart",
            dimension1: CustomerID,
            dimension2: City,
            dimension3: State,
            dimension4: Zip
        }

        if (cartData.step === 2) {
            obj.eventLabel = "Billing/Shipping Information";
        }

        if (cartData.step === 3) {
            obj.eventLabel = "Review Shopping Cart";
        }

        if (cartData.step === 4) {
            ecommerce.purchase = purchase;

            actionField.revenue = cartData.grandTotal;
            actionField.tax = cartData.salesTax;
            actionField.shipping = cartData.shipping;
            actionField.coupon = cartData.coupon

            obj.event = "transaction";
            obj.eventLabel = "Submit Order";
        }



        return obj;
    };

}